import React from 'react'
import { getUserPreferencesMeasurementUnit } from 'selectors/user/cookie'
import { formatDimensionInCm } from './helper'
import { Dimensions } from './styles'
import { useSelector } from 'react-redux'

type DimensionUnits = {
  width: number
  height: number
  depth: number
}
type Props = {
  dimensions: DimensionUnits
  isDepthVisible?: boolean
}

const DimensionsComponent = (props: Props) => {
  if (!props.dimensions) {
    return null
  }

  const measurementUnit = useSelector(getUserPreferencesMeasurementUnit)
  const {
    dimensions: { width, height, depth },
    isDepthVisible = true,
  } = props

  const depthString = isDepthVisible
    ? ` x ${formatDimensionInCm(depth, measurementUnit)} D ${measurementUnit}`
    : ''

  return (
    <Dimensions data-type='dimensions'>
      {`${formatDimensionInCm(width, measurementUnit)} W x ${formatDimensionInCm(
        height,
        measurementUnit
      )} H${depthString}`}
    </Dimensions>
  )
}

export default DimensionsComponent
